import { channelTypeInfo } from "../../models/ChannelType";
import ConnectableObject from "../../models/ConnectableObject";
import Page from "../../models/Page";
import { SequenceStep, enumActions } from "../Guide";
import GuideUtils from "../GuideUtils";
import guideSequence_addConsumerButton from "./guideSequence_addConsumerButton";
import guideSequence_addRoom from "./guideSequence_addRoom";
import guideSequence_addSceneMultiplexer from "./guideSequence_addSceneMultiplexer";
import openRoomOrFloorSequence from "./multibleSequencesHelp";

// ContextMenuLables.addFloors

function sequence(classNameFrom: string, classNameTo: string): Array<SequenceStep> {
  function getConnectableObj(className: string, other?: boolean): ConnectableObject | undefined {
    let obj: ConnectableObject | undefined;
    let page = state.objectRegistry.getObject(state.activePaneId) as Page;

    if (className == "Consumer") {
      let l = room?.consumers.findFirst((c) => channelTypeInfo(c.channelType).isLight);
      if (other) {
        page?.consumers.forEach((cons) => {
          if (channelTypeInfo(cons.channelType).isLight && cons != l) {
            l = cons;
          }
        });
      }
      obj = l;
    } else if (className == "Button") {
      obj = room?.buttons.sortBy("tag")[other ? 1 : 0];
    } else if (className == "Multiplexer" || className == "Scene") {
      state.sceneGroup.forEach((som) => {
        if (som.className == className) {
          if (obj == undefined || other) {
            obj = som;
          }
        }
      });
    }
    return obj;
  }
  function getDrawingId(className: string): string {
    let classNameIdRealtion = new Map<string, string>();
    classNameIdRealtion.set("Consumer", ".consumer"); // no itx
    classNameIdRealtion.set("Button", ".consumer"); // no itx
    classNameIdRealtion.set("Scene", "scene"); // no itx
    classNameIdRealtion.set("Multiplexer", "multiplexer"); // no itx
    return classNameIdRealtion.get(className || "") || "";
  }

  function getSequenceFromClassName(className: string): Array<SequenceStep> {
    if (className == "Consumer" || className == "Button") {
      return guideSequence_addConsumerButton(className);
    } else if (className == "Scene" || className == "Multiplexer") {
      return guideSequence_addSceneMultiplexer(className);
    }
    return [];
  }

  function connectConnectableObjs(
    fromObj: ConnectableObject,
    toObj: ConnectableObject,
    drawingAreaId: Array<string>,
    firstTime?: boolean,
  ): Array<SequenceStep> {
    fromElement = getConnectableObj(classNameFrom);
    let fromObjIdDrawing = getDrawingId(classNameFrom);
    let toObjIdDrawing = getDrawingId(classNameTo);
    return [
      {
        id: () => {
          let res = new Array<string>();
          if (classNameFrom == "Scene" || classNameFrom == "Multiplexer") {
            res.push("cabinet", "sceneGroups"); // no itx
          }
          res.push(fromObj.id, fromObjIdDrawing);
          return res;
        },
        action: enumActions.hover,
      },
      { action: enumActions.wait },

      {
        action: enumActions.hover,

        id: () => {
          let res = new Array<string>();
          if (classNameFrom == "Scene" || classNameFrom == "Multiplexer") {
            res.push(fromObj.id, ".connectorGrab");
            return res;
          }
          res.push(fromObj.id, ".connectorGrab");
          return res;
        },
      },
      {
        action: enumActions.mousedown,
        id: () => {
          let res = new Array<string>();
          if (classNameFrom == "Scene" || classNameFrom == "Multiplexer") {
            res.push(fromObj.id, ".connectorGrab");
            return res;
          }

          res.push(fromObj.id, ".triangleLeft");
          return res;
        },
        cursorType: "cross", // no itx
      },
      {
        action: enumActions.call,
        subSequence: () => {
          if (firstTime) {
            return [
              {
                action: enumActions.mousemove,
                id: drawingAreaId,
                positions: [[50, 20]], // in % des Target Elements
              },
            ];
          } else {
            return [];
          }
        },
      },

      {
        action: enumActions.mousemove,
        targetId: drawingAreaId,
        id: [...drawingAreaId, toObj.id, ".guideTarget"], // no itx
      },
      {
        action: enumActions.mouseup,
        id: [...drawingAreaId, toObj.id, ".guideTarget"], // no itx
        cursorType: "pointer",
      },

      {
        action: enumActions.unhover,
        id: [toObj.id, toObjIdDrawing],
      },
      {
        action: enumActions.unhover,
        id: [toObj.id, ".connectorGrab"], // no itx
      },

      {
        action: enumActions.wait,
      },

      //
      // Open last connectable obj....
      //
      // hier müssen wird mit mouse /down&up arbeiten
      // da der ButtonView nur mouseDown und mouseUp wg verschieben überwacht
      //

      {
        action: enumActions.mousedown,
        id: [...drawingAreaId, toObj.id],
      },
      {
        action: enumActions.mouseup,
        id: [...drawingAreaId, toObj.id],
      },
    ];
  }

  let drawingAreaId = GuideUtils.openRoomDrawingAreaId();
  let room = GuideUtils.openRoom();
  let toElement = getConnectableObj(classNameTo);
  let fromElement = getConnectableObj(classNameFrom);

  // let text = `Die Leuchte ${light?.tag} wird nun mit dem Taster ${firstButton.tag} verbunden `;

  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (state.allRooms().length == 0) {
          return [...guideSequence_addRoom("")];
        } else {
          return [];
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        drawingAreaId = GuideUtils.openRoomDrawingAreaId();
        room = GuideUtils.openRoom();
        toElement = getConnectableObj(classNameTo);
        fromElement = getConnectableObj(classNameFrom);
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        return [...openRoomOrFloorSequence({ roomGiven: room, connectableClassNameIn: [classNameFrom, classNameTo] })];
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        let res = new Array<SequenceStep>();
        room = GuideUtils.openRoom();
        toElement = getConnectableObj(classNameTo);
        fromElement = getConnectableObj(classNameFrom);
        if (toElement == undefined) {
          res.push(...getSequenceFromClassName(classNameTo));
        }
        if (fromElement == undefined) {
          res.push(...getSequenceFromClassName(classNameFrom));
        }
        res.push(...openRoomOrFloorSequence({ roomGiven: room, connectableClassNameIn: [classNameFrom, classNameTo] }));
        return res;
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        let res = new Array<SequenceStep>();
        drawingAreaId = GuideUtils.openRoomDrawingAreaId();
        room = GuideUtils.openRoom();
        toElement = getConnectableObj(classNameTo);
        fromElement = getConnectableObj(classNameFrom);

        if (fromElement && toElement && drawingAreaId) {
          res.push(...connectConnectableObjs(fromElement, toElement, drawingAreaId, true));
        }
        ///// bed wann zweite verbindung hinzugefügt erden soll
        if (room?.consumers.size == 3) {
          fromElement = getConnectableObj(classNameTo, true);
          toElement = getConnectableObj(classNameFrom);

          //get here other to element
          if (toElement && fromElement && drawingAreaId)
            res.push(...connectConnectableObjs(fromElement, toElement, drawingAreaId));
        }
        return res;
      },
    },
  ];
}

export default sequence;
